<template>
    <admin-layout>
        <template #header>
            <div class="flex justify-between">
                <div>
                    <h2 class="text-xl font-semibold leading-tight text-white">
                        Books
                    </h2>
                </div>
                <div>
                    <a href="/books/create">
                        <button class="flex items-center p-1 my-4 text-sm text-white bg-green-600 border rounded-md sm:text-base sm:px-4 sm:py-2 hover:text-white">
                            <div><strong class="text-lg">+</strong> New Book</div>    
                        </button>
                    </a>
                </div>
            </div>
        </template>
        <div class="py-12">
            <div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
                <div class="overflow-hidden bg-white shadow-xl sm:rounded-lg">
                    <TableBooks :rows="books" />
                </div>
            </div>
        </div>
    </admin-layout>
</template>

<script>
    import AdminLayout from '@/Layouts/AdminLayout'
    import TableBooks from '@/Components/Tables/TableBooks'

    export default {
        props: ["books"],
        components: {
            AdminLayout,
            TableBooks,
        },
    }
</script>